import React, { useEffect, useRef } from 'react';
import { observer } from 'mobx-react';
import { FormulaVM } from './FormulaVM';
import { Loader } from 'cd-eft/components/common/LoadingSpinner/LoadingSpinner';
import { Row, Col } from 'reactstrap';
import { useParams } from 'react-router-dom';
import { FormulaPrintModalContainer } from '../FormulaComponents/template/FormulaFormTemplates';
import { formulaLabelsConfig } from './Formula.labels.config';
import MessageCenter from 'cd-eft/components/common/MessageCenter/MessageCenterVM';
import { useHistory } from 'react-router-dom';
import { FormulaBanner } from '../FormulaComponents/Common/FormulaBanner';
import { FormulaContent } from './FormulaContent';
import { UnderConstruction } from 'cd-eft/components/common/UnderConstruction';
import pdfLogo from 'cd-eft/assets/images/pdf-blue.svg';
import './Formula.scss';
import '../FormulaContainer/FormulaContainer.scss';
import { StageDischargeGraph } from '../FormulaComponents/Common/StageDischargeGraph';
import { formatRoundS, updateToTenChars } from 'cd-eft/utils/mathUtilities';

const FormulaComponent = () => {
  const { formulaId }: any = useParams();
  const vm = useRef(new FormulaVM(formulaId)).current;
  const history = useHistory();

  useEffect(() => {
    vm.init(formulaId);
    if (vm.formulaProps.path === '') {
      history.replace('/analysis/hydraulic-formula')
    }

    return () => {
      MessageCenter.clearMessages();
    };
  }, [formulaId]);

  const makeUnitsGeneric = (key) => {
    if (key.specifyFor !== undefined && key.specifyFor.includes(vm.formulaProps.name)) {
      return (key.label as string).replace(key.replace, key.specificUnits).trim();
    }
    else return key.label;
  }
  return (
    <div className={`formula-container formula-${formulaId}`}>
      {/* Formula Banner */}
      <FormulaBanner title={vm.formulaTitle} help={vm.bannerHelpLink} />
      {/* Formula Content */}
      <div className="formula-content">
        {/* Formula Inputs */}
        {vm.formulaProps.id !== 0 ? <FormulaContent vm={vm} /> : <UnderConstruction />}
        <div className="results-container">
          {/* Formula Results */}
          {vm.hasResults ? (
            <div>
            <ResultsContainer>
              {Object.keys(vm.results)
                .filter((el) => !['errorResponse', 'validationPass'].includes(el))
                .map((key) => (
                  <Row key={`results-item-${key}`} className="col flex-nowrap" id={key}>
                    <Col className="result-label nobr">
                      {formulaLabelsConfig[key] ? makeUnitsGeneric(formulaLabelsConfig[key]) : key}:
                    </Col>
                  {vm.props === 'circular-section'? <Col className={vm.results[key].length > 30 ? '' : 'nobr'}>
                    {vm.results[key] = updateToTenChars(vm.results[key])}
                    </Col>: <Col className={vm.results[key].length > 30 ? '' : 'nobr'}>
                    {/* if value===0, it would be converted to '- - -'??? */}
                      {vm.results[key] ?
                        (typeof vm.results[key] === 'number'  && !isNaN(vm.results[key])
                          ? formatRoundS(vm.results[key], 2)
                          : vm.results[key]
                        )
                        : '- - -'
                      }
                    </Col>}                
                  </Row>
                ))}
            </ResultsContainer>
            {vm.plotData ? <StageDischargeGraph targetDivId={vm.targetDivID} plotData={vm.plotData} windowOptions={vm.windowOptions} forReport={false}/> : null}
            </div>
          ) : null}

          {/* Formula Description */}
          {vm.formulaProps.id !== 0 ? (
            <div className="formula-description">
              <p>
                {vm.formDescription}
                &nbsp;
                <a target="_blank" href={vm.bannerHelpLink}>
                  Learn More 
                  <img src={pdfLogo} alt={'PDF logo'} />
                </a>
              </p>
            </div>
          ) : null}
          

          {/* Formula Images */}
          {vm.formulaProps.id !== 0 ? (
            <div className="formula-images text-center">
              <img src={vm.image} alt={vm.hydraulicFormulaImageDescription} title={vm.formulaTitle} />
            </div>
          ) : null}
        </div>

        {vm.isLoading && <Loader message={''} />}
        <FormulaPrintModalContainer
          vm={vm}
          inputs={vm.exportedInputs}
          results={vm.exportedResults}
          images={[vm.image]}
          formulaName={vm.formulaTitle}
          windowOptions={vm.windowOptions}
          stageDischarge={vm.plotData !== undefined ? true : false}
          stageDischargeData={vm.plotData}
        />
      </div>
    </div>
  );
};
export const Formula = observer(FormulaComponent);

const ResultsContainer = (props: any) => {
  return (
    <div className="usa-summary-box formula-results" role="region">
      <Col className='usa-summary-box__body'>
       <Row><h2 className="sections-heading">Results</h2></Row>
       <Row>
         <Col><div className="row results-value-list">{props.children}</div></Col>
       </Row>
      </Col>
    </div>
  );
};

